import { DeleteOutline } from "@mui/icons-material";
import { Typography } from "@mui/material";

import BaseModal from "../components/BaseModal";
import { V2_COLORS } from "../constants/colors";

interface DeleteInvoiceModalProps {
  open: boolean;
  loading?: boolean;
  invoiceNo: string;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteInvoiceModal({
  open,
  loading,
  invoiceNo,
  onClose,
  onConfirm,
}: DeleteInvoiceModalProps) {
  return (
    <BaseModal
      open={open}
      title="Delete Invoice"
      loading={loading}
      confirmLabel="Delete"
      confirmColor={V2_COLORS.error}
      confirmIcon={<DeleteOutline sx={{ fontSize: 18 }} />}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <Typography variant="body1" color="textPrimary">
        Are you sure you want to delete invoice <strong>{invoiceNo}</strong>?
      </Typography>
      <Typography variant="body2" color="textSecondary" mt={1}>
        This action cannot be undone.
      </Typography>
    </BaseModal>
  );
}
